export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, data) {
      return dispatch('list', { basePath: 'api/providers', params: data }, { root: true })
        .then(response => {
          state.count = response.count
          if (data) state.currentPage = data.page
          return response.results
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/providers.js